import api from '@/api/index';

const namespaced = true;

const state = {
  keyActivitiesData: [],
  tripStatusOptions: [],
  visibilityOptions: [],
  typeActivityOptions: [],
  fileExport: {},
  tripStatusData: [],
  oeeLvl2Options: [],
  oeeMasters: [],
  activityStatusByTripStatus: []
};

const getters = {
  keyActivitiesData: (state) => state.keyActivitiesData,
  tripStatusOptions: (state) => state.tripStatusOptions,
  visibilityOptions: (state) => state.visibilityOptions,
  typeActivityOptions: (state) => state.typeActivityOptions,
  fileExport: (state) => state.fileExport,
  oeeLvl2Options: (state) => state.oeeLvl2Options,
  oeeMasters: (state) => state.oeeMasters,
  tripStatusData: (state) => state.tripStatusData,
  activityStatusByTripStatus: (state) => state.activityStatusByTripStatus
};

const mutations = {
  SET_KEY_ACTIVITIES_DATA: (state, payload) => {
    state.keyActivitiesData = payload;
  },
  SET_TRIP_STATUS_OPTIONS: (state, payload) => {
    state.tripStatusOptions = payload;
  },
  SET_VISIBILITY_OPTIONS: (state, payload) => {
    state.visibilityOptions = payload;
  },
  SET_TYPE_ACTIVITY_OPTIONS: (state, payload) => {
    state.typeActivityOptions = payload;
  },
  SET_FILE_EXPORT: (state, payload) => {
    state.fileExport = payload;
  },
  SET_OEE_LVL2_OPTIONS: (state, payload) => {
    state.oeeLvl2Options = payload;
  },
  SET_OEE_MASTERS: (state, payload) => {
    state.oeeMasters = payload;
  },
  SET_TRIP_STATUS_DATA: (state, payload) => {
    state.tripStatusData = payload;
  },
  SET_ACTIVITY_STATUS_BY_TRIP_STATUS_DATA: (state, payload) => {
    state.activityStatusByTripStatus = payload;
  }
};

const actions = {
  async fetchKeyActivities({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const params = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload
      }
      const { data } = await api.getKeyActivities(params);

      if (data.error) {
        commit('SET_KEY_ACTIVITIES_DATA', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_KEY_ACTIVITIES_DATA', data.data)
      commit('Table/SET_TOTAL_DATA', data.total ?? 0, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
      return data
    } catch (error) {
      throw error.data;
    }
  },

  async getTripStatusOptions({ commit }) {
    try {
      const { data } = await api.getTripStatus();

      commit('SET_TRIP_STATUS_OPTIONS', data.map(v => ({ value: v.code, text: v.name, color_code: v.color_code })))
      return data
    } catch (error) {
      throw error.data;
    }
  },

  async getTypeActivityOptions({ commit }) {
    try {
      const params = {
        type: 'TYPE_ACTIVITY'
      }
      const { data } = await api.getKeyActivityOptions(params);

      commit('SET_TYPE_ACTIVITY_OPTIONS', data.map(v => ({ value: v.name, text: v.name.replace('_', ' ').toLowerCase() })))
      return data
    } catch (error) {
      throw error.data;
    }
  },

  async postKeyActivity(_, payload) {
    try {
      const data = await api.postKeyActivity(payload);

      return data
    } catch (error) {
      throw error.data;
    }
  },

  async postKeyStatus(_, payload) {
    try {
      const data = await api.postKeyStatus(payload);
      
      return data
    } catch (error) {
      throw error.data;
    }
  },

  async putKeyActivity(_, payload) {
    try {
      const data = await api.putKeyActivity(payload.id, payload.form);

      return data
    } catch (error) {
      throw error.data;
    }
  },

  async putKeyStatus(_, payload) {
    try {
      await api.putKeyStatus(payload.id, payload.form);
    } catch (error) {
      throw error.data;
    }
  },

  async deleteKeyActivity(_, payload) {
    try {
      await api.deleteKeyActivity(payload);
    } catch (error) {
      throw error.data;
    }
  },

  async deleteKeyStatus(_, payload) {
    try {
      await api.deleteKeyStatus(payload);
    } catch (error) {
      throw error.data;
    }
  },

  async uploadAttachment({ commit }, payload) {
    try {
      // add start progress to change component state immediately
      commit('UploadFile/SET_PROGRESS', 0.25, { root: true })
      const { data } = await api.uploadKeyActivityFile(payload, (progress) => {
        const totalLength = progress.lengthComputable
          ? progress.total
          : progress.target.getResponseHeader('content-length')
              || progress.target.getResponseHeader('x-decompressed-content-length')
  
        commit('UploadFile/SET_PROGRESS', totalLength
          ? Math.round((progress.loaded * 100) / totalLength)
          : 100,
        { root: true })
      })
  
      if (data.error) {
        commit('UploadFile/SET_PROGRESS', 0, { root: true })
        commit('UploadFile/SET_IS_UPLOAD_ERROR', true, { root: true })
        return
      }

      commit('UploadFile/SET_FILE_NAME', data.file_name, { root: true })
      commit('UploadFile/SET_IS_UPLOAD_ERROR', false, { root: true })
    } catch (error) {
      commit('UploadFile/SET_PROGRESS', 0, { root: true })
      throw error
    }
  },
  async uploadAttachmentStatus({ commit }, payload) {
    try {
      const formData = new FormData()
      formData.append('file', payload.file)
      formData.append('status_id', payload.statusId)
  
      // add start progress to change component state immediately
      commit('UploadFile/SET_PROGRESS', 0.25, { root: true })
      const { data } = await api.uploadKeyStatusFile(formData, (progress) => {
        const totalLength = progress.lengthComputable
          ? progress.total
          : progress.target.getResponseHeader('content-length')
              || progress.target.getResponseHeader('x-decompressed-content-length')
  
        commit('UploadFile/SET_PROGRESS', totalLength
          ? Math.round((progress.loaded * 100) / totalLength)
          : 100,
        { root: true })
      })
  
      if (data.error) {
        commit('UploadFile/SET_PROGRESS', 0, { root: true })
        commit('UploadFile/SET_IS_UPLOAD_ERROR', true, { root: true })
        return
      }

      commit('UploadFile/SET_FILE_NAME', data.file_name, { root: true })
      commit('UploadFile/SET_IS_UPLOAD_ERROR', false, { root: true })
    } catch (error) {
      commit('UploadFile/SET_PROGRESS', 0, { root: true })
      throw error
    }
  },
  async exportKeyActivity({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const data = await api.exportKeyActivity({
        search: filterConfig.search,
        ...payload})
      if (data) {
        commit('SET_FILE_EXPORT', data)
      }
    } catch (error) {
      throw error.data;
    }
  },
  resetKeyActivityFileExport({ commit }) {
    commit('SET_FILE_EXPORT', {})
  },
  async fetchTripStatus({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const params = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload
      }
      const { data } = await api.getTripStatus(params);

      if (data.error) {
        commit('SET_TRIP_STATUS_DATA', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_TRIP_STATUS_DATA', data.data)
      commit('Table/SET_TOTAL_DATA', data.total ?? 0, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
      return data
    } catch (error) {
      throw error.data;
    }
  },
  async postTripStatus(_, payload) {
    try {
      const data = await api.postTripStatus(payload);

      return data
    } catch (error) {
      throw error.data;
    }
  },
  async putTripStatus(_, payload) {
    try {
      await api.putTripStatus(payload.id, payload.form);
    } catch (error) {
      throw error.data;
    }
  },
  async deleteTripStatus(_, payload) {
    try {
      await api.deleteTripStatus(payload);
    } catch (error) {
      throw error.data;
    }
  },
  async getActivityStatus(_, payload) {
    try {
      const { data } = await api.getActivityStatus(payload)
  
      return data
    } catch (err) {
      throw err
    }
  },
  async getVisibilityOptions({ commit }) {
    try {
      const params = {
        type: 'VISIBILITY'
      }
      const { data } = await api.getKeyActivityOptions(params);

      commit('SET_VISIBILITY_OPTIONS', data.map(v => ({ value: v.name, text: v.name })))
    } catch (error) {
      throw error.data;
    }
  },
  async getOeeLvl2({ commit }) {
    try {
      const { data } = await api.getOeeLvl2()

      commit('SET_OEE_LVL2_OPTIONS', data)
      return data
    } catch (err) {
      throw err
    }
  },
  async getOeeMasters({ commit }) {
    try {
      const { data } = await api.getOeeMasters()

      commit('SET_OEE_MASTERS', data)
      return data
    } catch (err) {
      throw err
    }
  },
  async getActivityStatusByTripStatus({ commit }, payload) {
    try {
      const { data }  = await api.getActivityStatusByTripStatus(payload);
      commit('SET_ACTIVITY_STATUS_BY_TRIP_STATUS_DATA', data)
    } catch (error) {
      throw error.data;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
